require('./widgets/ReactApp/ReactDesktop');
